import { connect } from 'react-redux';

import { getUser } from 'store/reducers/user';
import {
  navigateToEditProfileScreen,
  navigateToLoginScreen,
  navigateToRegisterScreen,
} from 'actions/gigya-router-actions';

import DefaultHeaderAuth from './DefaultHeaderAuth';

const mapStateToProps = (state) => ({
  user: getUser(state),
});

const mapDispatchToProps = {
  register: navigateToRegisterScreen,
  login: navigateToLoginScreen,
  profileDetails: navigateToEditProfileScreen,
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeaderAuth);
